import type { OrderStatus, SenderStatus } from "@/api/custom_types";
import { useGetStatusInformation } from "@/services";
import { useMemo } from "react";

export function useStatusMap() {
	const { data } = useGetStatusInformation();
	const orderStatusMap = useMemo(() => {
		const list = data?.order_status_attributes ?? [];

		return list.reduce(
			(acc, { status, ...rest }) => {
				acc[status as OrderStatus] = rest as Omit<
					(typeof list)[number],
					"status"
				>;
				return acc;
			},
			{} as Record<OrderStatus, Omit<(typeof list)[number], "status">>,
		);
	}, [data]);

	const senderStatusMap = useMemo(() => {
		const list = data?.sender_status_attributes ?? [];

		return list.reduce(
			(acc, { status, ...rest }) => {
				acc[status as SenderStatus] = rest as Omit<
					(typeof list)[number],
					"status"
				>;
				return acc;
			},
			{} as Record<SenderStatus, Omit<(typeof list)[number], "status">>,
		);
	}, [data]);

	return { orderStatusMap, senderStatusMap };
}
